import {
  clearLocalCognitoSession,
  hubAmplifySignOut,
} from '@/utils/auth/clearMfaSessionSatisfaction';
import { completeNewPasswordChallenge } from '@/utils/aws/cognito/amplifyAuth';
import { useState } from 'react';

export default function useNewPassword(formData, cognitoResponse, updateSnack) {
  const [loading, setLoading] = useState(false);

  const handleNewPasswordSubmit = async () => {
    try {
      setLoading(true);
      const trimPassword = formData.newPassword.trim();

      // The cognitoResponse user is already SRP-based (created in useLogin under USER_SRP_AUTH)
      // So we can call completeNewPassword directly without switching auth flow types
      await completeNewPasswordChallenge(cognitoResponse, trimPassword);

      // After password is set, user needs to log in again with their new password
      // This will trigger MFA if needed via the normal custom auth flow
      // Wrap sign-out in separate try-catch to handle failures independently
      try {
        await hubAmplifySignOut({
          reason: 'new-password-cleanup',
          userEmail: formData.email?.trim(),
        });
      } catch (signOutError) {
        // Log sign-out failure but don't fail the entire operation
        // Password was already successfully changed
        console.error('Sign-out failed after password change:', signOutError);
        await clearLocalCognitoSession();
      }

      // Show success message - parent component will handle state reset
      // Always show success if password change succeeded, regardless of sign-out outcome
      updateSnack({
        severity: 'success',
        message:
          'Password set successfully. Please sign in with your new password.',
      });

      return { success: true, requiresReLogin: true };
    } catch (error) {
      updateSnack({
        severity: 'error',
        message: `Failed to create new password: ${error.message}`,
      });
      return { error };
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    handleNewPasswordSubmit,
  };
}
